<div class="container">
  <h2 class="my-5">Tours</h2>

  <section class="row">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Chartered Fishing Tours</h3>
      <p>
        Taniti's coastal waters are teeming with a variety of fish species, making the island an ideal destination for fishing
        enthusiasts. Licensed operators offer chartered fishing tours that depart daily from the main marina near Merriton Landing.
        Whether you're a seasoned angler or a first-time participant, these tours provide a safe and guided experience, with all
         necessary equipment provided. Half-day and full-day options are available, and many tours include the opportunity to catch
         tuna, mahi-mahi, marlin, and other prized game fish. Knowledgeable local guides ensure a rewarding experience while sharing
         insights about the region's marine ecology.
      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row">
    <div class="col-md-9">
      <h3>Bus &amp; Boat Tours</h3>
      <p>
        For those who prefer a more relaxed way to explore the island, a variety of scenic boat and bus tours are available. Boat tours
        provide a unique perspective of Taniti's coastline, with many offering stops at secluded beaches, snorkeling locations, and
        cultural sites accessible only by water. Inland, comfortable, air-conditioned buses transport visitors across the island, with
        narrated tours that highlight Taniti's rich history, local traditions, and natural beauty. These guided excursions are an excellent
        option for families, seniors, or anyone wishing to see the island's highlights without the demands of more strenuous activities.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

  <hr class="my-5">

  <section class="row">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Rainforest Hiking Tours</h3>
      <p>
        Taniti's lush tropical rainforest offers a breathtaking setting for guided hiking tours. These hikes, led by experienced local
        naturalists, take visitors through dense jungle paths, across wooden footbridges, and to hidden waterfalls. Along the way,
        hikers may encounter native bird species, colorful flora, and even glimpses of the island's unique wildlife. Tours vary in
        difficulty and duration, making it possible for both casual walkers and seasoned hikers to find a suitable route. Visitors are
        encouraged to wear sturdy footwear and bring water, as well as to follow all safety and conservation guidelines provided by
        their guides.
      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row">
    <div class="col-md-9">
      <h3>Volcano Tours</h3>
      <p>
        A highlight of any trip to Taniti is a visit to the island's active volcano. Guided volcano tours provide an educational and
        awe-inspiring experience, offering insight into Taniti's geological history and the powerful natural forces that shaped the
        island. Visitors can explore volcanic rock formations, steam vents, and panoramic lookout points with the help of expert guides.
        Some tours include short hikes to observation areas, while others feature interpretive centers with exhibits on volcanic
        activity and its impact on the local environment. These tours are designed to be both informative and accessible, making them
        suitable for visitors of all ages.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

</div>
